import { useEffect } from 'react';

interface IFrameInstamedInterface {
  showIFrame: boolean;
  setShowIFrame: (show: boolean) => void;
  setToken: (token: string) => void;
  setExpDate: (expDate: string) => void;
}

export const IFrameInstamed = ({
  showIFrame,
  setShowIFrame,
  setToken,
  setExpDate,
}: IFrameInstamedInterface) => {
  const corpId = 'medstation.exp@instamed.net';


  useEffect(() => {
    if (showIFrame) {
      (window as any).setToken = setToken;
      (window as any).setExpDate = setExpDate;
      (window as any).setShowIFrame = setShowIFrame;

      const script1 = document.createElement('script');
      const script2 = document.createElement('script');
      const inlineScript = document.createElement('script');

      script1.src = 'https://code.jquery.com/jquery-3.3.1.min.js';
      script1.async = true;
      script1.onload = () => {
        script2.src = 'https://cdn.instamed.com/content/js/token.js';
        script2.setAttribute('data-displaymode', 'incontext');
        script2.setAttribute('data-corporateid', corpId);
        script2.setAttribute('data-mobiledisplaymode', 'incontext');
        script2.async = true;
        script2.onload = () => {
          inlineScript.innerHTML = `
            function handleResponse(data) {
                if (data.Status == "Cancelled") {
                  $('#instamedcardinfo').hide();
                } else {
                  if (data.Token) window.setToken(data.Token);
                  if (data.ExpDate) window.setExpDate(data.ExpDate);
                  window.setShowIFrame(false);
                }
                if(!InstaMed2.isMobile()) {
                  $('#instamed').remove();
                }
              }

            var iframename = 'instamed';

           function addCard() {
             var url = InstaMed2.addCard(handleResponse, null, 'https://pay.instamed.com/', true, "${corpId}");
              
              var iframe = document.getElementById(iframename);

              // Verificar se o iframe já existe
              if (!iframe) {
                // Se o iframe não existir, cria um novo
                iframe = document.createElement('IFRAME');
                iframe.name = iframename;
                iframe.setAttribute('name', iframename);
                iframe.setAttribute('id', iframename);
                iframe.setAttribute('width', 600);
                iframe.setAttribute('height', 400);
                document.body.appendChild(iframe);
              }

              iframe.setAttribute('src', url);
              
              if (InstaMed2.isEmbedded()) {
              } else if (InstaMed2.isInContext()) {
                document.getElementById(iframename).setAttribute('src', url);
              } else {
                InstaMed2.childWindow = window.open(url);
              }
            }

        
            function onloadHelper() {
              if (typeof InstaMed2 !== 'undefined') {
                InstaMed2.isInContext = function() { return true; };
                InstaMed2.corporateID = "${corpId}";
                InstaMed2.onReady();
                addCard();
              } else {
                console.error('InstaMed2 is not defined');
              }
            }
            onloadHelper();
          `;
          document.body.appendChild(inlineScript);
        };
        document.body.appendChild(script2);
      };
      document.body.appendChild(script1);

      return () => {
        document.body.removeChild(script1);
        document.body.removeChild(script2);
        document.body.removeChild(inlineScript);
        
        delete (window as any).setToken;
        delete (window as any).setExpDate;
        delete (window as any).setShowIFrame;
      };
    }
  }, [showIFrame]);

  const htmlContent = `
    <input type="text" id="cardinput" style="display:none;">
    <input type="hidden" id="txtCardNumber" name="txtCardNumber">
    <input type="hidden" id="txtExpDate" name="txtExpDate">`;

  return showIFrame ? (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  ) : (
    <></>
  );
};
